import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, Optional } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { PlatformType } from "@root/config";
import { pick, omit } from "lodash";
import { NzModalRef } from "ng-zorro-antd/modal";
import { AccountService } from "../../account.service";
import { ActivatedRoute, Router } from "@angular/router";
import { postMsg } from "@root/router/public/h5/channel/util";

@Component({
  selector: "v4-connect-with-vrbo",
  templateUrl: "./connect-with-vrbo.component.html",
  styleUrls: ["./connect-with-vrbo.component.scss"],
})
export class V4ConnectWithVrboComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12 md:bottom-0 md:left-auto md:right-0
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;
  // 以下两个接口调用的booking的验证接口，因为后端没写新接口...
  private readonly VerifySendApi = "/api/thirdparty/get_booking_code";
  private readonly VerifySubmitApi = "/api/thirdparty/post_booking_code";

  @Input() verifyData;

  form: UntypedFormGroup = this.fb.group({
    username: null,
    password: null,
    thirdparty_type: PlatformType.Vrbo,
  });

  verifyForm: UntypedFormGroup = this.fb.group({
    phone_id: null, // 打电话需要的id
    // sms_id: null, // 发短信需要的id
    verify_type: null,
    code: null,
  });

  accountId;
  step = 1;
  loading = false;

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    @Optional() private modalRef: NzModalRef,
    private accountSrv: AccountService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.verifyData) {
      console.log("verifyData: ", this.verifyData);
      this.step = 2;
      this.accountId = this.verifyData.accountId;
      this.verifyForm.patchValue({ phone_id: this.verifyData.phoneId });
    }
  }

  onClickCreate() {
    this.loading = true;
    const params = this.form.value;
    this.accountSrv.createAccount(params).subscribe((rst: any) => {
      // this.http.post(this.CreateApi, params).subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        const { id } = rst.data;
        this.accountId = id;
        this.requestLogin();
      }
    });
  }

  onClickVerifyType(type: "sms" | "call") {
    this.verifyForm.patchValue({
      verify_type: type,
    });
    this.requestVerifyByType();
  }

  onClickSubmitCode() {
    this.requestSubmitVerifyCode();
  }

  onCancel() {
    if (this.modalRef) {
      this.modalRef.destroy();
    } else {
      postMsg("BACK");
    }
  }

  // onFinish() {
  //   this.modalRef.destroy("success");
  // }

  private requestLogin() {
    this.loading = true;
    const params = { id: this.accountId };
    this.accountSrv.accountLogin(params).subscribe((rst: any) => {
      // this.http.post(this.LoginApi, params).subscribe((rst: any) => {
      this.loading = false;

      const { error_code, data } = rst;
      if (error_code === 213006) {
        // const payload = {
        //   "id": "c5254f356709d241c847896a3ecf6dc3",
        //   "phone": "+86*******0090"
        // };
        const payload = data.vrbo.call;
        // const { call, sms } = data.vrbo;
        this.verifyForm.patchValue({
          phone_id: payload.id,
          // phone_id: call?.[0]?.id,
          // sms_id: sms?.[0]?.id
        });
        this.step = 2;
      }
      if (error_code === 0) {
        this.navigate();
        // this.modalRef.destroy("success");
      }
    });
  }

  private requestVerifyByType() {
    const value = this.verifyForm.value;
    const params = {
      id: this.accountId,
      ...omit(value, ["code"]),
    };
    this.http.get(this.VerifySendApi, { params }).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.step = 3;
      }
    });
  }

  private requestSubmitVerifyCode() {
    this.loading = true;
    const params = {
      id: this.accountId,
      ...pick(this.verifyForm.value, ["code"]),
    };
    this.http.post(this.VerifySubmitApi, params).subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        // this.step = 4;
        this.navigate();
        // this.modalRef.destroy("success");
      }
    });
  }

  private navigate() {
    if (this.modalRef) {
      this.modalRef.destroy("success");
    } else {
      this.router.navigate(["../set-price-ratio"], {
        relativeTo: this.route,
        queryParams: { thirdparty_type: PlatformType.Vrbo },
      });
    }
  }
}
